import { NgClass } from '@angular/common';
import {

  AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, ElementRef, afterRenderEffect, computed, inject, input,
  signal, viewChild
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: '[title] ds-footer-widget',
  imports: [NgClass, TranslatePipe],
  templateUrl: './footer-widget.component.html',
  styleUrls: ['./footer-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.--footer-widget-scroll-duration]': 'animationSpeed()' }
})
export class FooterWidgetComponent implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly wrapper = viewChild<ElementRef<HTMLDivElement>>('wrapper');
  private readonly textContent = viewChild<ElementRef<HTMLParagraphElement>>('textContent');
  private readonly measurement = afterRenderEffect(() => this.measureOverflow());

  public readonly title = input('');
  public readonly text = input('');
  public readonly climacon = input<string | null>(null);
  public readonly mailIcon = input(false);
  public readonly textHorizontalScroll = input(false);
  public readonly hasTextOverflow = signal<boolean | null>(null);
  public readonly isMeasuring = computed(() => this.hasTextOverflow() === null);
  public readonly animationSpeed = computed(() => `${(this.text()?.length ?? 0) / 4}s`);

  public ngAfterViewInit(): void {
    const observer = new ResizeObserver(() => this.measureOverflow());
    observer.observe(this.wrapper().nativeElement);
    observer.observe(this.textContent().nativeElement);
    this.destroyRef.onDestroy(() => observer.disconnect());
  }

  private measureOverflow(): void {
    this.text();
    const wrapper = this.wrapper()?.nativeElement;
    const textContent = this.textContent()?.nativeElement;
    this.hasTextOverflow.set(this.textHorizontalScroll() && Boolean(wrapper && textContent)
      && wrapper.scrollWidth < textContent.scrollWidth);
  }
}
